import LetterAvatar from "@/components/Avatar/LetterAvatar"

export const columns = [
  {
    header: "Adjusted By",
    cell: ({ row }) => (
      <LetterAvatar
        name={row.original.createdBy?.name}
        subtitle={row.original.createdBy?.phone}
      />
    ),
  },
  {
    header: "Reference No",
    accessorKey: "reference_no",
  },
  {
    header: "Code",
    accessorKey: "code",
  },
  {
    header: "Date",
    accessorKey: "date",
  },
]
